<template>
	<div class="projectDetail-container">
		<div v-loading="loading" class="project-detail-content">
			<!-- 详情-表格数据 -->
			<div class="common-detail-table">
				<table>
					<colgroup>
						<col width="180" />
						<col />
						<col width="180" />
						<col />
					</colgroup>
					<tr>
						<th>项目名称</th>
						<td>{{ projectPerformanceIndicatorDetail.projectName }}</td>
						<th>数据等级</th>
						<td>{{ projectPerformanceIndicatorDetail.dataLevel }}</td>
					</tr>
					<tr>
						<th>业绩记录编号</th>
						<td>{{ projectPerformanceIndicatorDetail.performanceCode }}</td>
						<th>项目编号</th>
						<td>{{ projectPerformanceIndicatorDetail.projectCode }}</td>
					</tr>
					<tr>
						<th>企业名称</th>
						<td>{{ projectPerformanceIndicatorDetail.companyName }}</td>
						<th>统一社会信用代码</th>
						<td>{{ projectPerformanceIndicatorDetail.companyCode }}</td>
					</tr>
					<tr>
						<th>业绩类型</th>
						<td>{{ projectPerformanceIndicatorDetail.performanceTypeName }}</td>
						<th>业绩对应资质标准及等级</th>
						<td>{{ projectPerformanceIndicatorDetail.indicatorLevel }}</td>
					</tr>
					<tr>
						<th>工作开始时间</th>
						<td>{{ projectPerformanceIndicatorDetail.workStartTime }}</td>
						<th>工作结束时间</th>
						<td>{{ projectPerformanceIndicatorDetail.workEndTime }}</td>
					</tr>
					<tr>
						<th>工程项目规模等级及详细技术指标</th>
						<td colspan="3">{{ projectPerformanceIndicatorDetail.performanceIndicator }}</td>
					</tr>
				</table>
			</div>

			<!-- 批量数据切换 -->
			<div class="tab-pane-container">
				<!-- tab头部区域--start -->
				<div class="tab-pane-header">
					<!-- tab选项 -->
					<div class="tab-pane-navs">
						<div
							v-for="(item, index) in detailTabs"
							:key="index"
							:class="['tab-pane-item', { active: activeTabIndex === index }]"
							@click="activeTabIndex = index"
						>
							{{ item.name }}
						</div>
					</div>
				</div>
				<!-- tab头部区域--end -->
				<!-- tab内容区域--start -->
				<div class="tab-pane-content">
					<!-- 相关人员 -->
					<div :class="['tab-pane-content__item', { active: activeTabIndex === 0 }]">
						<data-table
							:table-data="projectPerformanceIndicatorDetail.performanceList"
							:column="personColumns"
							:page-hide="true"
							:border="false"
						></data-table>
					</div>
				</div>
			</div>
		</div>
		<!-- 未开通会员提示 -->
		<nonbind-vip v-if="isVip"></nonbind-vip>
		<!-- 未开通超级会员提示 -->
		<nonbind-svip v-if="isSVip"></nonbind-svip>
	</div>
</template>

<script>
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import NonbindSvip from '@/components/NonBind/nonbindSVip.vue'
	import DataTable from '@/components/JrTable/DataTable.vue'
	import { transObject } from '@/utils/index'
	import { getProjectPerformanceIndicatorDetail } from '@/api/qualificationQuery/project'

	// 业绩技术指标详情
	export default {
		name: 'PerformanceIndicatorDetails',
		components: {
			DataTable,
			NonbindVip,
			NonbindSvip
		},
		props: {
			id: {
				type: String,
				required: true,
				default: ''
			}
		},
		data() {
			return {
				detailTabs: [{ name: '相关人员' }],
				activeTabIndex: 0,

				// 数据加载状态
				loading: false,
				isVip: false,
				isSVip: false,
				// 业绩指标详情对象
				projectPerformanceIndicatorDetail: {
					// 项目名称
					projectName: '',
					// 数据等级
					dataLevel: '',
					// 业绩记录编号
					performanceCode: '',
					// 项目编号
					projectCode: '',
					// 企业名称
					companyName: '',
					// 统一社会信用代码
					companyCode: '',
					// 业绩类型
					performanceType: '',
					performanceTypeName: '',
					// 业绩对应资质标准及等级
					indicatorLevel: '',
					// 工作开始时间
					workStartTime: '',
					// 工作结束时间
					workEndTime: '',
					// 业绩指标
					performanceIndicator: '',
					// 相关人员
					performanceList: []
				},
				personColumns: [
					{ label: '人员姓名', prop: 'personName', align: 'center' },
					{ label: '人员证件号码', prop: 'idCard', align: 'center' },
					{ label: '本人在工程中所起的作用', prop: 'projectName', align: 'center' },
					{ label: '数据等级', prop: 'level', align: 'center' }
				],
				relevantPersonnelList: [], //相关人员
				message: ''
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.handleQueryProjectPerformanceIndicatorDetail()
		},
		methods: {
			// 查询业绩技术指标详情
			handleQueryProjectPerformanceIndicatorDetail() {
				this.loading = true
				const params = {
					projectPerformanceIndicatorId: this.id
				}

				getProjectPerformanceIndicatorDetail(params)
					.then(response => {
						const { data, code, message } = response

						if (code === 6102) {
							this.isVip = true
						} else if (code === 6104) {
							// 当前是svip 权益已经使用完，提示次数已经用完了，请等待会员权益重置再使用
							this.$message.warning(message)
						} else if (code === 6105) {
							// 当前是vip 权益已经使用完，提示次数已经用完了，请用户升级为svip
							this.isSVip = true
						} else {
							if (data) {
								// 将目标数据转为我指定的属性对象
								transObject(data, this.projectPerformanceIndicatorDetail)
							}
						}
						this.loading = false
					})
					.catch(error => {
						this.loading = false
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/tab-pane.scss';
	@import '~@/styles/table.scss';
	@import '../../styles/project.scss';
</style>
